import { Checkbox, Collapse, Divider, Form, Input, message, Slider } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { useTranslation } from 'react-i18next'
import OrderPlaylistForm from '../../components/PlaylistFolder/OrderPlaylistForm'
import PlaylistsTable from '../../components/PlaylistsTable'
import { MusicGenre, Order } from '../../utils/redux/ordersSlice'
import { attemptCreatePlaylist, CreatePlaylistDTO } from '../../utils/redux/playlistsSlice'
import { listenerMiddleware, store, useAppDispatch } from '../../utils/redux/store'
interface Props {
  order: Order
}
export default function ClientRequest({order}: Props) {
  const { t } = useTranslation('orders')

  const dispatch = useAppDispatch()

  const [orderForm] = Form.useForm<Order>()
  const businessName = Form.useWatch('businessName', orderForm)

  const isLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptCreatePlaylist,
    onFulfilled: () => {
      message.success('Playlist has been created successfully!')
      orderForm.resetFields()
      orderForm.setFieldsValue({})
    },
    onRejected(action, listenerApi) {
      message.error("Error creating playlist")
    },
  })

  function onFinish(values: CreatePlaylistDTO) {
    dispatch(attemptCreatePlaylist({ userOrder: order._id, ...values }))
  }

  return (
    <Collapse
    defaultActiveKey={['order']}
    items={[
      {
        key: 'order',
        label: 'Order information',
        children:
        <Form initialValues={order} layout="vertical" form={orderForm}>
          <Form.Item name={'businessName'} label="Client name">
            <Input readOnly />
          </Form.Item>
          <Form.Item name={'activityType'} label="Activity">
            <Input readOnly />
          </Form.Item>
          <Form.Item name={'address'} label="Address">
            <Input readOnly />
          </Form.Item>
          <Divider>
            {t("Information about '{{- businessName}}' clients", {
              businessName,
            })}
          </Divider>
          <Form.Item
            name={'age18_30'}
            label={t('% of visitors aged {{- MIN_AGE}} to {{- MAX_AGE}}', {
              ns: 'library',
              MIN_AGE: 18,
              MAX_AGE: 30,
            })}
          >
            <Slider max={100} min={0}  disabled />
          </Form.Item>
          <Form.Item
            name={'age31_45'}
            label={t('% of visitors aged {{- MIN_AGE}} to {{- MAX_AGE}}', {
              ns: 'library',
              MIN_AGE: 31,
              MAX_AGE: 45,
            })}
          >
            <Slider max={100} min={0}  disabled />
          </Form.Item>
          <Form.Item
            name={'age46_60'}
            label={t('% of visitors aged {{- MIN_AGE}} to {{- MAX_AGE}}', {
              ns: 'library',
              MIN_AGE: 46,
              MAX_AGE: 60,
            })}
          >
            <Slider max={100} min={0}  disabled />
          </Form.Item>
          <Form.Item
            name={'styles'}
            label={t('Styles')}
          >
            <Checkbox.Group options={Object.values(MusicGenre).map(style => ({
              value: style,
              label: t(style)
            }))} disabled/>
          </Form.Item>

            <Form.Item
              name={'vocalToInstrumental'}
              label={t('Vocal - Instrumental ratio')}
            >
              <Slider max={100} min={0} disabled />
            </Form.Item>

          <Form.Item
            name={'internationalToLocal'}
            label={t('International - Local ratio')}
          >
            <Slider max={100} min={0} disabled />
          </Form.Item>
        </Form>
      },
      {
        key: 'playlist-assigned',
        label: 'Assigned playlists',
        children: <PlaylistsTable playlists={order.playlists} />
      },
      {
        key: 'playlist',
        label: 'Assign new playlist',
        children: 
        <OrderPlaylistForm
          isLoading={isLoading}
          uploadedDestination={'playlists'}
          onFinish={onFinish}
        />
      },
      // ...(assignedPlaylists?.length ? assignedPlaylists : []),
    ]}
  />
  )
}
